<template>
  <div style="margin-bottom: 0" v-if="category">
    <template v-if="editText">
      <div class="text-xs-center" v-if="isLoading" style="padding-top: 15px; padding-bottom: 15px">
        <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
      </div>
      <div
        v-else
        class="category-name form-control"
        :class="{ 'has-error': errors.has('categoryname') }"
        style="width: 100%"
      >
        <v-layout>
          <v-flex style="max-width: 50px; width: 50px">
            <uploadfile
              ref="answer"
              v-model="category.image_url"
              :height="50"
              data-vv-as="Image"
              :data-vv-name="'Image'"
              v-validate
            >
              <v-btn flat fab small><v-icon small>camera_alt</v-icon></v-btn>
            </uploadfile>
            <v-btn fab small flat @click="category.image_url = null">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-flex>
          <v-flex class="pl-3">
            <input
              v-validate="`excluded: ${categoryname}`"
              ref="category"
              type="text"
              name="categoryname"
              :data-vv-as="$t('Category name')"
              v-model="category.name"
              :placeholder="$t('Enter Category Name')"
            />
            <span class="text-error" v-if="errors.has('categoryname')">{{
              errors.first('categoryname')
            }}</span>
          </v-flex>
        </v-layout>

        <div class="text-xs-center">
          <v-btn outline color="grey" @click="onCancelEditCategory">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="editCategory">{{ $t('Save') }}</v-btn>
        </div>
      </div>
    </template>
    <template v-else>
      <div style="display: flex; align-items: stretch">
        <div class="move-vertical text-xs-center">
          <slot name="move"></slot>
        </div>
        <v-flex class="ml-2">
          <v-switch
            @change="updateHiddenStatus"
            :true-value="false"
            :false-value="true"
            v-model="category.hiddenstatus"
            color="primary"
            inset
          ></v-switch>
        </v-flex>
        <div class="category-name text-truncate form-control ignore-elements">
          <v-layout>
            <v-flex style="max-width: 50px; width: 50px">
              <template v-if="category.image_url">
                <v-img :src="category.image_url" :width="'50'" :max-width="'50'" />
              </template>
              <div v-else style="height: 50px; width: 100%; background: #eee"></div>
            </v-flex>
            <v-flex class="ml-3">
              {{ category.name }}
            </v-flex>
          </v-layout>
        </div>
        <div class="action text-xs-right ignore-elements">
          <v-btn
            fab
            outline
            color="primary"
            small
            class="extra-small ma-1"
            v-if="!editText"
            @click="onEditCategory"
          >
            <em class="fa fa-pencil-alt" aria-hidden="true" />
          </v-btn>
        </div>
        <div @click="$emit('selectCat', category.id)">
          <v-icon style="margin-top: 15px" color="primary">keyboard_arrow_right</v-icon>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import api from '@/api'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import uploadfile from '@/components/elements/uploadfile'
export default {
  props: ['value', 'categorylist', 'categoryid'],
  data: function () {
    return {
      category: undefined,
      editText: false,
      isLoading: false
    }
  },
  mounted: function () {
    var vm = this

    vm.category = vm.value
    vm.cached_category = JSON.stringify(vm.value)
  },
  components: {
    PulseLoader,
    uploadfile
  },
  computed: {
    categoryname() {
      return this.categorylist.filter((v) => v.id !== this.value.id).map((v) => v.name)
    },
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    }
  },
  methods: {
    updateHiddenStatus(e) {
      let vm = this
      let data = {
        pageid: this.pageid,
        categoryid: this.categoryid,
        name: vm.category.name,
        id: vm.category.id,
        image_url: vm.category.image_url,
        hiddenstatus: vm.category.hiddenstatus
      }
      api.kfcEditSubCategory(data, function (error, response) {
        vm.isLoading = false
        vm.editText = false
        vm.cached_category = JSON.stringify(vm.category)
        vm.$emit('input', vm.category)
        vm.$emit('close')
      })
    },
    onDeleteCategory: function () {
      this.$emit('onDelete', this.category.id)
    },
    pressEnter: function () {
      if (e.keyCode === 13) {
        this.editCategory()
      }
    },
    onCancelEditCategory: function () {
      var vm = this
      vm.category = JSON.parse(vm.cached_category)
      vm.$emit('input', vm.category)
      vm.editText = false
    },
    onEditCategory: function () {
      var vm = this
      vm.editText = true
      vm.$nextTick(function () {
        if (vm.category && vm.editText) {
          vm.$refs.category.focus()
        }
      })
    },
    editCategory: function () {
      let vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        let data = {
          pageid: this.pageid,
          categoryid: this.categoryid,
          name: vm.category.name,
          id: vm.category.id,
          image_url: vm.category.image_url,
          hiddenstatus: vm.category.hiddenstatus
        }
        vm.isLoading = true
        api.kfcEditSubCategory(data, function (error, response) {
          vm.isLoading = false
          vm.editText = false
          vm.cached_category = JSON.stringify(vm.category)
          vm.$emit('input', vm.category)
          vm.$emit('close')
        })
      })
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      // console.log(newVal,this.$refs.tagInput.innerText)
      if (newVal != oldVal) {
        this.category = this.value
        this.cached_category = JSON.stringify(this.value)
        // this.$refs.tagInput.innerText = this.value.name
      }
      // this.text = this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.move-vertical {
  border-right: 1px solid #eee;
  padding: 10px;
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce-sub-category-edit-kfc.vue